module.exports = __webpack_public_path__ + "static/media/bg-support-base.6b18758a.png";